import CompanyAnnualList from '@/pages/components/company-info/company-annual/CompanyAnnualList';

export default{
    list: CompanyAnnualList,
    recordRepresentation: 'companyAnnual',
}